import { RedoOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { Box, Flex } from 'atoms';
import { ButtonWrapper } from 'components';
import { FilterAtnButton } from 'utils/commonStyled';
import { ClearFilterButton, FilterTag, FilterTagsContainer, LtSearchBar } from './styles';

function TableHeaderSection({
	handleSearch,
	handleReset,
	handleResetFilters,
	setOpen,
	cityValue,
	tempValue,
	timeValue,
	statusValue,
	batteryStatusValue,
	alertStatusValue,
	cityAllValue,
	timeAllValue,
	statusAllValue,
	batteryStatusAllValue,
	alertStatusAllValue,
	validArray,
	isConnected,
}) {
	const filterOptions = [
		{ id: 'cityValue', value: cityValue },
		{ id: 'tempValue', value: tempValue },
		{ id: 'timeValue', value: timeValue },
		{ id: 'statusValue', value: statusValue },
		{ id: 'batteryStatusValue', value: batteryStatusValue },
		{ id: 'alertStatusValue', value: alertStatusValue },
		{ id: 'cityAllValue', value: cityAllValue },
		{ id: 'timeAllValue', value: timeAllValue },
		{ id: 'statusAllValue', value: statusAllValue },
		{ id: 'batteryStatusAllValue', value: batteryStatusAllValue },
		{ id: 'alertStatusAllValue', value: alertStatusAllValue },
	];

	const getConnectionStatus = () => {
		if (isConnected === undefined) return { text: 'Connecting', color: '#f39c12' };
		return isConnected
			? { text: 'Live', color: '#2ecc71' }
			: { text: 'Disconnected', color: '#e74c3c' };
	};

	const connectionStatus = getConnectionStatus();

	return (
		<Flex mt={3} alignItems="center" justifyContent="space-between">
			<Box flex="0 0 30%">
				<LtSearchBar
					placeholder="Search by Trip ID, Vehicle Number, etc."
					enterButton="Search"
					allowClear
					onSearch={handleSearch}
				/>
			</Box>
			<Box flex="0 0 35%" className="filter-hightlight">
				<Box flex="0 0 35%" display="flex">
					<FilterAtnButton onClick={() => setOpen(true)}>FILTERS</FilterAtnButton>
					<FilterTagsContainer>
						{filterOptions
							.filter((filter) => filter.value)
							.map(({ id, value }) => (
								<FilterTag key={id}>{value}</FilterTag>
							))}

						{validArray.length > 0 && (
							<Tooltip title="Clear filter">
								<ClearFilterButton onClick={handleResetFilters} />
							</Tooltip>
						)}
					</FilterTagsContainer>
				</Box>
			</Box>
			<Box>
				<Flex alignItems="center">
					<Box
						style={{
							width: '15px',
							height: '15px',
							borderRadius: '50%',
							backgroundColor: connectionStatus.color,
							marginRight: '5px',
						}}
					/>
					<Box
						style={{
							fontSize: '14px',
							fontWeight: 'bold',
							color: connectionStatus.color,
						}}
					>
						{connectionStatus.text}
					</Box>
				</Flex>
			</Box>
			<Box>
				<ButtonWrapper onClick={handleReset} icons={<RedoOutlined />}>
					SYNC
				</ButtonWrapper>
			</Box>
		</Flex>
	);
}

export default TableHeaderSection;

TableHeaderSection.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	handleReset: PropTypes.func.isRequired,
	handleResetFilters: PropTypes.func.isRequired,
	setOpen: PropTypes.func.isRequired,
	cityValue: PropTypes.string,
	tempValue: PropTypes.string,
	timeValue: PropTypes.string,
	statusValue: PropTypes.string,
	batteryStatusValue: PropTypes.string,
	alertStatusValue: PropTypes.string,
	cityAllValue: PropTypes.string,
	timeAllValue: PropTypes.string,
	statusAllValue: PropTypes.string,
	batteryStatusAllValue: PropTypes.string,
	alertStatusAllValue: PropTypes.string,
	validArray: PropTypes.array,
	isConnected: PropTypes.bool,
};
